import React from 'react';
import humidityImage from '../images/humidity.png'
import 'bootstrap/dist/css/bootstrap.min.css'
import {Dropdown} from "react-bootstrap";
import temperatureImage from "../images/temperature.png";

// get the humidity from the server
class fetchHumidity extends React.Component {
 
    state = {
        loading: true,
        userData: null,
        error: null
    };

    async componentDidMount() {
        try {
            const response = await fetch('https://iot-temphumid.herokuapp.com/humidity', {
                credentials: "include"
            });
            const json = await response.json();

            // get the last humidity value, if there is no value, display 0
            let humidity = json.length > 0 ? json[json.length - 1].humidity : "Can't get the humidity value";

            this.setState({
                loading: false,
                humidity: humidity
            });
        } catch (error) {
            this.setState({
                loading: false,
                error: error
            });
        }         
    }

    render() {
        const { loading, humidity, error } = this.state;

        if (loading) {
            return <p>Loading...</p>;
        }

        if (error) {
            return <p>{error.message}</p>;
        }

        return (
            // center the humidity value
            
            <div className="container text-center">
                <div className="row">
                    <div className="col-sm-12">
                        <h1>Humdity</h1>
                        <h2>{humidity} {this.state.unit} %</h2>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <img src={humidityImage} alt="temperature" className="img-fluid" width="300" height="300"/>
                    </div>
                </div>
            </div>
        );
    }
}

export default fetchHumidity;